import React from 'react';

const CheckboxPaper: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 128 128" {...props}>
    <path
      fill="#fff"
      d="M63.501 52.79l-5.352 5.39V64H52.34l-2.22 2.226L47.897 64h-11.16V42.546h21.411v.456l5.353-5.337v-.483H31.384v32.182H63.5V52.79z"
    ></path>
    <path
      fill="#fff"
      d="M46.667 51.369l-3.8 3.808 7.252 7.24 23.313-23.331-3.801-3.808-19.512 19.577-3.452-3.486zm16.834 41.648l-5.352 5.39v5.82H52.34l-2.22 2.226-2.222-2.226H36.737V82.773h21.411v.456l5.353-5.337v-.483H31.384v32.182H63.5V93.017z"
    ></path>
    <path
      fill="#fff"
      d="M46.667 91.596l-3.8 3.808 7.252 7.241 23.313-23.332-3.801-3.808-19.512 19.577-3.452-3.486z"
    ></path>
    <path
      fill="#fff"
      d="M100.971 123a8.024 8.024 0 005.677-2.356 8.055 8.055 0 002.352-5.689V33.4L80.656 5H26.03c-2.13 0-4.171.848-5.677 2.356A8.053 8.053 0 0018 13.046v101.909c0 2.133.846 4.18 2.352 5.689A8.024 8.024 0 0026.029 123h74.942zM82.235 14.145l17.638 17.673H84.912c-.71 0-1.39-.282-1.893-.785a2.685 2.685 0 01-.784-1.897V14.145zm-58.882 100.81V13.045c0-.71.282-1.393.784-1.896a2.674 2.674 0 011.892-.785h50.853v18.772c0 2.134.846 4.18 2.352 5.69a8.021 8.021 0 005.678 2.356h18.735v77.773c0 .711-.282 1.393-.784 1.896a2.673 2.673 0 01-1.892.785H26.029c-.71 0-1.39-.282-1.892-.785a2.684 2.684 0 01-.784-1.896z"
    ></path>
    <path
      fill="#fff"
      d="M92.943 50.59h-16.06v5.364h16.06v-5.363zm0 42.91h-16.06v5.364h16.06V93.5z"
    ></path>
  </svg>
);

export default CheckboxPaper;
